import React from "react";
import { Link } from "react-router-dom";
import toSeoUrl from "@functions/toSeoUrl";
import V3SessionButton from "@components/V3/V3SessionButton";
import { getSessionType } from "@utils/ticketUtils";

const SecondarySessions = ({ movieTitle, secondarySessions = {} }) => {

    if (Object.keys(secondarySessions).length < 1) {
        return (
            <>
                <h2 className="no-sessions-available">
                    Nearby cinemas also playing {movieTitle}
                </h2>
                <div className="sessions-available__message">
                    <p className="sessions-available__message-title">
                        Sorry, we couldn&apos;t find any results nearby to your chosen cinema
                    </p>
                    <p className="sessions-available__message-text">
                        Please select from one of the sessions above, or select a different date
                    </p>
                </div>
            </>
        );
    }

    return (
        <div className="other-venues-sessions">
            <h2 className="no-sessions-available">
                Nearby cinemas also playing {movieTitle}
            </h2>
            {Object.entries(secondarySessions).map(([, sessions]) => {
                const first = sessions[0];
                return (
                    <div key={first.venue_id} className="sessions-available__venue-group">
                        <Link
                            className="sessions-available__venue-title"
                            to={`/venue/${first.venue_id}/${toSeoUrl(first.venue_name)}`}
                        >
                            {first.venue_name} - {first.venue_distance ?? "?"} km
                        </Link>
                        <div className="sessions-available__list">
                            {sessions.map((session) => {
                                const experience_type = getSessionType(session);
                                return (
                                    <V3SessionButton
                                        key={session.id}
                                        session={{ ...session, experience_type }}
                                    />
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default SecondarySessions;
